module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"titleTravelers":"VOYAGEURS","traveler":"Voyageur","lastName":"Nom","firstName":"Prénom","dateBirth":"Date de naissance","addTraveler":"Ajouter un voyageur","required":"Champs requis"},"en":{"titleTravelers":"TRAVELERS","traveler":"Traveler","lastName":"Last Name","firstName":"First Name","dateBirth":"Date of birth","addTraveler":"Add a Traveler","required":"Required"}}')
  delete Component.options._Ctor
}
